// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.doc_req_pop[data-v-71dc4054] {width:910px; height: 800px; overflow-y: scroll;}\n.doc_req_pop > .layer_close[data-v-71dc4054] {z-index: 10;}\n.div_cntr_area + .div_cntr_area[data-v-71dc4054] {margin-top: 5px;}\n.text_link[data-v-71dc4054] {color: #000; padding-left: 2px;}\n.text_link[data-v-71dc4054]:hover {text-decoration: underline !important;}\n.attdel[data-v-71dc4054] {cursor: pointer;}\n", ""]);
// Exports
module.exports = exports;
